import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { ThemeProvider } from "./ui/ThemeContext.jsx";
import { ConsentProvider } from "./ui/CookieConsent.jsx";
import { FxProvider } from "./lib/useFxRates.jsx";
import App from "./App.jsx";
import "./index.css";

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <ThemeProvider>
      <FxProvider>
        <HelmetProvider>
          <BrowserRouter>
            <ConsentProvider>
              <App />
            </ConsentProvider>
          </BrowserRouter>
        </HelmetProvider>
      </FxProvider>
    </ThemeProvider>
  </React.StrictMode>
);
